import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Grid, Typography, IconButton } from "../../components/ui";
import { toast } from "react-toastify";
import axios from "axios";
import axiosInstance from "../../axios/axiosInstance";
import { ArrowBackIosNewRounded as ArrowBackIosNewRoundedIcon } from "../../components/icons";
const CompanyDetails = () => {
  const id = useParams();
  const navigate = useNavigate();

  const [companyData, setCompanyData] = useState<any>(null);

  const handleGetCompany = async (id: any) => {
    try {
      const resp: any = await axiosInstance.get(`/api/company/${id?.id}`);
      if (resp.status === 200) {
        setCompanyData(resp.data?.data);
      }
    } catch (error) {
      toast.error("Failed to retrieve company");
      console.error("Error fetching company data:", error);
    }
  };

  useEffect(() => {
    id && handleGetCompany(id);
  }, [id]);
  return (
    <div>
      <Grid container p={2} spacing={2}>
        <Grid size={12}>
          <Typography fontSize={20} fontWeight={500} color="#111827">
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIosNewRoundedIcon
                fontSize="small"
                sx={{ color: "#111827" }}
              />
            </IconButton>{" "}
            Company Details
          </Typography>
        </Grid>
        <Grid size={12} display={"flex"} justifyContent={"space-between"}>
          <Typography fontSize={20} fontWeight={500} color="#111827">
            Company name : {companyData?.name}
          </Typography>
          <Typography fontSize={20} fontWeight={500} color="#111827">
            Floor : {companyData?.floor}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Typography fontSize={18} fontWeight={500} color="#111827">
            Members
          </Typography>
        </Grid>
        <Grid size={12}>
          {companyData?.users?.map((member: any, index: number) => (
            <Grid
              key={index}
              size={6}
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Typography fontSize={16} fontWeight={500} color="#111827">
                {index + 1}. {member.name}
              </Typography>
              <Typography fontSize={16} fontWeight={500} color="#111827">
                Phone : {member?.phone}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </div>
  );
};

export default CompanyDetails;
